import type { Guide } from '../types';
import { builders } from './helpers';

// The Insights guide (29 October 2026): starting a chat insights report, what it costs, reading it, and the monthly
// report. Words under guide.insights.*. Owners and admins only, like the page.

const { link, howLink, step, how, section, howTo } = builders('insights');
const L = {
  insights: link('insights', '/insights'),
  knowledge: link('knowledge', '/knowledge'),
  coach: link('coach', '/flows?tab=coach'),
  contacts: link('contacts', '/contacts'),
  broadcasts: link('broadcasts', '/broadcasts'),
  billing: link('billing', '/billing'),
  notifications: link('notifications', '/settings/notifications'),
  howReport: howLink('howReport', 'report')
};

export const INSIGHTS_GUIDE: Guide = {
  id: 'insights',
  version: 1,
  titleKey: 'guide.insights.title',
  introKey: 'guide.insights.intro',
  routes: ['/insights'],
  tour: [
    step('welcome', '/insights'),
    step('new', '/insights', 'insights-new', [L.howReport]),
    step('list', '/insights', 'insights-list'),
    step('settings', '/insights', 'insights-settings', [L.notifications]),
    step('help', '/insights', 'insights-help')
  ],
  howTos: [
    howTo('report', [
      how('report', 'open', '/insights', 'insights-new'),
      how('report', 'choose', '/insights', 'insights-new-form', { open: 'insights-new' }),
      how('report', 'wait', '/insights', 'insights-list', { links: [L.notifications] })
    ])
  ],
  sections: [
    section('what', 2, 1, [L.insights]),
    section('cost', 2, 1, [L.billing]),
    section('read', 3, 1, [L.knowledge, L.coach]),
    section('act', 2, 0, [L.knowledge, L.contacts, L.broadcasts]),
    section('monthly', 1, 1, [L.notifications])
  ]
};
